import React from 'react';
import { Box, LinearProgress, Typography } from '@mui/material';
import EmptyReportSection from './EmptyReportSection';
import { reportStyles } from './styles';

export default function BreakdownBars({
  entries = [],
  total = 0,
  color = 'error',
  emptyMessage = 'No breakdown data was returned.',
}) {
  if (entries.length === 0) {
    return <EmptyReportSection>{emptyMessage}</EmptyReportSection>;
  }

  return (
    <Box sx={reportStyles.breakdownList}>
      {entries.map(([label, count]) => {
        const percentage = total > 0 ? Math.round((count / total) * 100) : 0;

        return (
          <Box key={label}>
            <Box sx={reportStyles.breakdownRow}>
              <Typography variant="body2" sx={reportStyles.breakdownLabel}>
                {label}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {count} ({percentage}%)
              </Typography>
            </Box>
            <LinearProgress
              variant="determinate"
              value={percentage}
              sx={reportStyles.breakdownProgress(color, count)}
            />
          </Box>
        );
      })}
    </Box>
  );
}
